module.exports = __webpack_public_path__ + "static/media/OSTR02.6eadefac.jpg";